const GA_ID = "G-CD4J6W4C5P";
const CONSENT_KEY = "nw_cookie_consent";

const hasConsent = () => localStorage.getItem(CONSENT_KEY) === "accepted";
const gtagReady = () => typeof window.gtag === "function";

// gtag.js is only downloaded after the visitor accepts analytics cookies.
const loadGa = () => {
  if (document.getElementById("ga4-script")) return;
  const script = document.createElement("script");
  script.id = "ga4-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
};

export const trackEvent = (name, params = {}) => {
  if (hasConsent() && gtagReady()) window.gtag("event", name, params);
};

let landingTracked = false;
// Landing page_view only; later SPA route changes are captured by GA4 enhanced measurement (history events).
export const trackPageView = (path = window.location.pathname) => {
  if (landingTracked || !hasConsent()) return;
  landingTracked = true;
  trackEvent("page_view", { page_path: path, page_location: window.location.href, page_title: document.title });
};

export const setAnalyticsConsent = (granted) => {
  localStorage.setItem(CONSENT_KEY, granted ? "accepted" : "declined");
  if (!gtagReady()) return;
  window.gtag("consent", "update", { analytics_storage: granted ? "granted" : "denied" });
  if (granted) {
    loadGa();
    trackPageView();
  }
};

// Track every phone / WhatsApp click anywhere on the site (consented visitors only).
export const initClickTracking = () => {
  if (hasConsent()) loadGa();
  document.addEventListener("click", (e) => {
    const link = e.target.closest?.("a[href]");
    if (!link) return;
    const href = link.getAttribute("href");
    if (href.startsWith("tel:")) trackEvent("phone_click", { phone_number: href.slice(4), link_location: window.location.pathname });
    else if (href.includes("wa.me") || href.includes("whatsapp")) trackEvent("whatsapp_click", { link_location: window.location.pathname });
  }, { capture: true });
};
